import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { setLastWorkspaceId } from '@/shared/lib/last-workspace'

export const Route = createFileRoute(
  '/$lang/workspace/$workspaceId/agents/new',
)({
  beforeLoad: ({ context, params }) => {
    requireAuthenticated(context, params)
    setLastWorkspaceId(params.workspaceId)

    throw redirect({
      to: '/$lang/organization/agents/new',
      params: { lang: params.lang },
      replace: true,
    })
  },
})
